import { Box, IconButton, Icons, Stack, Typography } from '@healthinal/ui';
import { FileDetailsDto, UserDto } from '../../../../../api/generated/model';
import { formatDateWithGermanMonth } from '../../../../../utils/date.ts';
import { FileLink } from '../../../../components/FileLink.tsx';

const STATUS_ICON_SLOT_WIDTH = '1.5rem';

export function ConditionComplianceCardRow({
  showDanger = false,
  showStatusIcon = false,
  date,
  createdBy,
  status,
  fileDetails,
  onEdit,
}: {
  showDanger?: boolean;
  showStatusIcon?: boolean;
  date: string;
  createdBy?: UserDto | null;
  status: string;
  fileDetails?: FileDetailsDto | null;
  onEdit?: () => void;
}) {
  const statusIcon = showStatusIcon ? (
    showDanger ? (
      <Icons.HighlightOff color={'danger'} />
    ) : (
      <Icons.Check />
    )
  ) : null;

  return (
    <Stack direction={'row'} alignItems={'center'} gap={1}>
      <Stack flex={1} justifyContent={'center'}>
        <Typography level={'title-sm'}>{formatDateWithGermanMonth(date)}</Typography>
        <Typography level={'body-sm'}>
          {createdBy?.lastName} {createdBy?.firstName}
        </Typography>
      </Stack>
      <Stack flex={2} gap={0.5} justifyContent={'center'}>
        <Stack direction={'row'} alignItems={'center'} gap={1}>
          {statusIcon && (
            <Box
              sx={{
                width: STATUS_ICON_SLOT_WIDTH,
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              {statusIcon}
            </Box>
          )}
          <Typography
            level={'body-sm'}
            color={showDanger ? 'danger' : undefined}
            textColor={showDanger ? undefined : 'text.secondary'}
            sx={{ flex: 1, minWidth: 0 }}>
            {status}
          </Typography>
        </Stack>
        {fileDetails && (
          <Stack direction={'row'} gap={1}>
            {showStatusIcon && <Box sx={{ width: STATUS_ICON_SLOT_WIDTH, flexShrink: 0 }} />}
            <FileLink fileDetails={fileDetails} />
          </Stack>
        )}
      </Stack>
      {onEdit && (
        <IconButton color={'primary'} onClick={onEdit} title={'Compliance bearbeiten'} sx={{ flexShrink: 0 }}>
          <Icons.Edit />
        </IconButton>
      )}
    </Stack>
  );
}
